/* RemixOriginalSong.js */

import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, FormGroup, Label, Input, Collapse } from 'reactstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import Strings from '../../translations/Translations';
import { useAuth } from '../../context/auth/AuthContext';
import Assets from '../../services/Assets';
import { toast } from 'react-toastify';
import Button1 from '../buttons/Button1';
import PSO from '../../services/PSO';
import OriginalSongCard1 from '../media/OriginalSongCard1';

export default function RemixOriginalSong({ originalSong, callback, removeOriginalSong }) {
  const { toggleLoading, authenticated } = useAuth();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const [publicAllowedUse, setPublicAllowedUse] = useState(0);
  const [genre, setGenre] = useState();
  const [genres, setGenres] = useState();

  const [loading, setLoading] = useState(false);
  const [collapseMoreOptions, setCollapseMoreOptions] = useState(false);
  const [collapseMusicLinks, setCollapseMusicLinks] = useState(false);

  const getGenres = useCallback(async () => {
    toggleLoading(true);
    try {
      const response = await Assets.getGenresList();
      if (response && response.length > 0) {
        const options = [];
        response.forEach((value) => {
          if (parseInt(value.ID) !== 0) {
            options.push({ value: value.ID, label: value.Name });
          }
        });
        if (options && options.length > 0) {
          setGenres(options);
        }
      }
    } catch (err) {
      toast.error(`${Strings('error_while_getting_genres')} [ID==04]`);
    }
    toggleLoading(false);
  }, [toggleLoading, setGenres]);
  useEffect(() => { getGenres(); }, [getGenres]);

  const onSubmit = useCallback(async (data) => {
    let valid = true;
    const osge = (genre) ? genre.value : null;

    if (data.osfile.length === 0) {
      valid = false;
      toast.error(Strings('song_file_is_required'));
    }
    if (genre === null || osge === '0' || osge === 0) {
      valid = false;
      toast.error(Strings('song_genre_is_required'));
    }

    if (valid) {
      const args = {
        osba: data.osba,
        osso: data.osso,
        osge: osge,
        ospau: publicAllowedUse,
        un: authenticated.un,
        al: authenticated.al
      };

      // Optional fields
      if (data.oswe) { args.oswe = data.oswe; }
      if (data.ospe) { args.ospe = data.ospe; }
      if (data.osemail) { args.osemail = data.osemail; }
      if (data.ostel) { args.ostel = data.ostel; }

      // Music links
      if (data.oslapple) { args.oslapple = data.oslapple; }
      if (data.oslspotify) { args.oslspotify = data.oslspotify; }
      if (data.oslyoutube) { args.oslyoutube = data.oslyoutube; }
      if (data.oslyoutubemusic) { args.oslyoutubemusic = data.oslyoutubemusic; }
      if (data.oslamazon) { args.oslamazon = data.oslamazon; }
      if (data.oslsoundcloud) { args.oslsoundcloud = data.oslsoundcloud; }
      if (data.osldeezer) { args.osldeezer = data.osldeezer; }
      if (data.osltidal) { args.osltidal = data.osltidal; }
      if (data.oslcustom) { args.oslcustom = data.oslcustom; }

      const songFile = data.osfile[0];

      setLoading(true);
      try {
        const response = await PSO.uploadUserSong(args, songFile);
        if (response && response.result === 'success' && response.element_id) {
          reset({
            osba: '',
            osso: '',
            oswe: '',
            ospe: '',
            osemail: '',
            ostel: '',
            oslapple: '',
            oslspotify: '',
            oslyoutube: '',
            oslyoutubemusic: '',
            oslamazon: '',
            oslsoundcloud: '',
            osldeezer: '',
            osltidal: '',
            oslcustom: '',
            osfile: ''
          });

          const eid = response.element_id;
          const originalSongObj = { eid, osba: data.osba, osso: data.osso  };
          if (genre && genre.label) { originalSongObj.genre = genre.label; }
          if (callback) { callback(originalSongObj); }

          toast.success(Strings('original_song_successfully_uploaded'));
        } else {
          const errorText = (response && response.errorText) ? response.errorText : Strings('error_on_uploading_original_song');
          toast.error(errorText);
        }
      } catch (err) {
        toast.error(Strings('error_on_uploading_original_song'));
      }
      setLoading(false);
    }
  }, [authenticated, genre, publicAllowedUse, reset, callback]);

  return (
    <>
      {originalSong && (
        <>
          <Row className='mb-2'>
            <Col>
              <OriginalSongCard1 originalSong={originalSong} removeOriginalSong={removeOriginalSong} />
            </Col>
          </Row>

          <Row>
            <Col>
              <div className='alert alert-secondary'>
                {Strings('already_uploaded_song_message')}
              </div>
            </Col>
          </Row>
        </>
      )}

      {typeof(originalSong) === 'undefined' && (
        <>
          <Row className='mb-3'>

            <Col md={8}>

              <Row>
                <Col>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('song_name')}</Label>
                    <input type='text' className='form-control shadow pb-input-1' name='osso' {...register('osso', { required: true })} />
                    {errors && errors.osso && errors.osso.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('song_name_is_required')}</p>}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('band_name')}</Label>
                    <input type='text' className='form-control shadow pb-input-1' name='osba' {...register('osba', { required: true })} />
                    {errors && errors.osba && errors.osba.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('band_name_is_required')}</p>}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('genre')}</Label>
                    <Select className='pb-select2' value={genre} onChange={(value) => { setGenre(value); }} options={genres} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup switch>
                    <Input
                      type='switch'
                      checked={publicAllowedUse}
                      onClick={() => setPublicAllowedUse(!publicAllowedUse)}
                      onChange={() => {}}
                    />
                    <Label check>{Strings('public_allowed_use')}</Label>
                  </FormGroup>
                </Col>
              </Row>

              <div className='mt-3'>
                <Row className='mb-2'>
                  <Col>
                    <span className='primary-color cursor-pointer text-decoration-underline' onClick={() => setCollapseMoreOptions(!collapseMoreOptions)}>
                      {Strings('more_options')}
                    </span>
                  </Col>
                </Row>
                <Collapse isOpen={collapseMoreOptions}>
                  <Row>
                    <Col md={6}>
                      <Label>{Strings('website')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oswe' {...register('oswe')} />
                    </Col>
                    <Col md={6}>
                      <Label>{Strings('person')}</Label>
                      <input type='text' className='form-control shadow pb-input-1' name='ospe' {...register('ospe')} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label>{Strings('email')}</Label>
                      <input type='email' className='form-control shadow pb-input-1' name='osemail' {...register('osemail')} />
                    </Col>
                    <Col md={6}>
                      <Label>{Strings('phone')}</Label>
                      <input type='text' className='form-control shadow pb-input-1' name='ostel' {...register('ostel')} />
                    </Col>
                  </Row>
                </Collapse>
              </div>

              <div className='mt-3'>
                <Row className='mb-2'>
                  <Col>
                    <span className='primary-color cursor-pointer text-decoration-underline' onClick={() => setCollapseMusicLinks(!collapseMusicLinks)}>
                      {Strings('music_links')}
                    </span>
                  </Col>
                </Row>
                <Collapse isOpen={collapseMusicLinks}>
                  <Row className="mt-2">
                    <Col md={4}>
                      <Label>{Strings('ml_apple_music')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslapple' {...register('oslapple')} />
                    </Col>
                    <Col md={4}>
                      <Label>{Strings('ml_spotify')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslspotify' {...register('oslspotify')} />
                    </Col>
                    <Col md={4}>
                      <Label for="oslyoutube">{Strings('ml_youtube')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslyoutube' {...register('oslyoutube')} />
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col md={4}>
                      <Label>{Strings('ml_youtube_music')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslyoutubemusic' {...register('oslyoutubemusic')} />
                    </Col>
                    <Col md={4}>
                      <Label>{Strings('ml_amazon_music')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslamazon' {...register('oslamazon')} />
                    </Col>
                    <Col md={4}>
                      <Label>{Strings('ml_soundcloud')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslsoundcloud' {...register('oslsoundcloud')} />
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col md={4}>
                      <Label>{Strings('ml_deezer')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='osldeezer' {...register('osldeezer')} />
                    </Col>
                    <Col md={4}>
                      <Label>{Strings('ml_tidal')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='osltidal' {...register('osltidal')} />
                    </Col>
                    <Col md={4}>
                      <Label for="oslcustom">{Strings('ml_custom_url')}</Label>
                      <input type='url' className='form-control shadow pb-input-1' name='oslcustom' {...register('oslcustom')} />
                    </Col>
                  </Row>
                </Collapse>
              </div>

            </Col>

            <Col md={4}>

              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('song_file')}</Label>
                    <input
                      type='file'
                      className='form-control'
                      name='osfile'
                      {...register('osfile', { required: true })}
                    />
                    {errors && errors.osfile && errors.osfile.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('song_file_is_required')}</p>}
                  </FormGroup>
                </Col>
              </Row>
              
            </Col>

          </Row>

          <Row>
            <Col>
              <Button1
                className='pb-btn-1'
                onClick={handleSubmit(onSubmit)}
                loading={loading}
                disabled={loading}
              >
                {Strings('submit')}
              </Button1>
            </Col>
          </Row>
        </>
      )}
      
    </>
  );
}
